import type React from 'react';
import { DateTypography } from '@/components/DateTypography/DateTypography';
import { Image } from '@/components/ImageAvatar/ImageAvatar';
import { STORAGE } from '@/constants';
import { useColorMode } from '@/hooks';
import type { IComment } from '@/types';
import { CommentItemUserName } from './Chat.styles';

interface CommentItemHeaderProps {
    children?: React.ReactNode;
    user: IComment['user'];
    updatedAt: IComment['updated_at'] | Date;
}

export const CommentItemHeader = (props: CommentItemHeaderProps) => {
    const { children, user, updatedAt } = props;
    const isDarkMode = useColorMode();

    return (
        <div className="flex flex-wrap w-full">
            <div>
                {user.assets.length ? (
                    <Image
                        src={STORAGE + user.assets[0]?.path}
                        alt={user.name}
                        title={user.name}
                        width="32px"
                        height="32px"
                        variant="rounded"
                        margin="0 8px 0 0"
                    />
                ) : (
                    <Image src={' '} alt={user.name} title={user.name} width="32px" height="32px" />
                )}
            </div>

            <div>
                <CommentItemUserName color={isDarkMode ? 'primary' : 'text.primary'}>{user.name}</CommentItemUserName>
                <DateTypography date={updatedAt} />
            </div>

            {children && <div className="inline-flex ml-auto gap-[8px]">{children}</div>}
        </div>
    );
};
